import { useState } from "react";
import { Download, Eye, Loader2, Mail } from "lucide-react";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";
import { docUrl } from "@/data/documents";

function EmailForm({ doc, onDone }) {
  const [email, setEmail] = useState("");
  const [state, setState] = useState({ busy: false, msg: "", ok: false });
  const send = async (e) => {
    e.preventDefault();
    setState({ busy: true, msg: "", ok: false });
    try {
      await api.post(doc.private ? "/documents/manual/email" : "/documents/email", { email, doc_ids: [doc.id], base_url: window.location.origin });
      setState({ busy: false, msg: `Sent to ${email}`, ok: true });
      setEmail("");
    } catch (err) {
      setState({ busy: false, msg: errMsg(err), ok: false });
    }
  };
  return (
    <form onSubmit={send} className="mt-4 space-y-2" data-testid={`doc-email-form-${doc.id}`}>
      <div className="flex gap-2">
        <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="name@company.com" className="bg-[#080D1A] h-10" data-testid={`doc-email-input-${doc.id}`} />
        <button type="submit" disabled={state.busy} className="btn-accent px-4 text-sm flex items-center gap-2 disabled:opacity-60" data-testid={`doc-email-send-${doc.id}`}>
          {state.busy && <Loader2 className="w-4 h-4 animate-spin" />}Send
        </button>
      </div>
      {state.msg && <p className={`text-xs ${state.ok ? "text-emerald-400" : "text-red-400"}`} data-testid={`doc-email-msg-${doc.id}`}>{state.msg}</p>}
      {!state.ok && <button type="button" onClick={onDone} className="text-xs text-slate-500 hover:text-slate-300">Cancel</button>}
    </form>
  );
}

export function DocumentCard({ doc, active, onView }) {
  const [emailing, setEmailing] = useState(false);
  const btn = "border border-[#334155] text-slate-200 hover:border-amber-500 transition-colors px-3 py-2 text-sm flex items-center gap-2";
  return (
    <div className={`panel p-6 ${active ? "border-amber-500" : ""}`} data-testid={`doc-card-${doc.id}`}>
      <p className="font-mono text-[11px] uppercase tracking-wider text-slate-500">PDF · {doc.version} · {doc.pages} page{doc.pages > 1 ? "s" : ""}</p>
      <h2 className="text-2xl font-bold text-slate-100 mt-2">{doc.title}</h2>
      <p className="text-sm text-slate-400 mt-1">{doc.text}</p>
      <div className="flex flex-wrap gap-2 mt-5">
        <button onClick={() => onView(doc)} className={`${btn} hidden md:flex`} data-testid={`doc-view-${doc.id}`}><Eye className="w-4 h-4" />View</button>
        <a href={docUrl(doc)} target="_blank" rel="noreferrer" className={`${btn} md:hidden`} data-testid={`doc-view-mobile-${doc.id}`}><Eye className="w-4 h-4" />View</a>
        <a href={docUrl(doc)} download={doc.file} className={btn} data-testid={`doc-download-${doc.id}`}><Download className="w-4 h-4" />Download</a>
        <button onClick={() => setEmailing(true)} className={btn} data-testid={`doc-email-${doc.id}`}><Mail className="w-4 h-4" />Email</button>
      </div>
      {emailing && <EmailForm doc={doc} onDone={() => setEmailing(false)} />}
    </div>
  );
}
